export enum AuthFlow {
  Login = "login",
  OAuth = "oauth",
}
